if (!customElements.get('tcl-product-sticky-controller')) {
  customElements.define('tcl-product-sticky-controller', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      const root = this.closest('product-info');
      this.bar = root?.querySelector('.sticky-container_box');
      this.productSection = root?.querySelector('.product_box > .product');
      this.primaryActions = this.productSection?.querySelector('.product__info-wrapper .buy_buttons_box .product-form__buttons');
      if (!this.bar || !this.primaryActions) return;

      this.schedule = () => {
        if (this.frame == null) {
          this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            if (!this.isConnected) return;
            const bounds = this.primaryActions.getBoundingClientRect();
            const visible = bounds.height > 0 && bounds.bottom <= 0;
            if (this.bar.classList.contains('is-visible') !== visible) {
              this.bar.classList.toggle('is-visible', visible);
            }
          });
        }
      };

      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      window.addEventListener('load', this.schedule);
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.productSection);
      }
      this.schedule();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      if (this.schedule) {
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        window.removeEventListener('load', this.schedule);
      }
      if (this.frame != null) window.cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.frame = null;
      this.observer = null;
      this.schedule = null;
      this.bar = null;
      this.productSection = null;
      this.primaryActions = null;
    }
  });
}
